var map = {
	"./product1.jpg": 3987,
	"./product1_1.jpg": 1281,
	"./product1_2.jpg": 9504,
	"./product1_3.jpg": 9666,
	"./product1_4.jpg": 6158,
	"./product2.jpg": 919,
	"./product2_1.jpg": 3963,
	"./product2_2.jpg": 2934,
	"./product2_3.jpg": 4203,
	"./product2_4.jpg": 5153,
	"./product3.jpg": 9804,
	"./product3_1.jpg": 5023,
	"./product3_2.jpg": 2504,
	"./product3_3.jpg": 5941,
	"./product3_4.jpg": 8735
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1797;